import { SxProps } from '@mui/material';

export const commonButtonStyle: SxProps = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "6px",
  padding: "8px 16px",
  border: "1px solid #D0D5DD",
  backgroundColor: "#FAFAFA",
  color: "#101828",
  fontWeight: 600,
  fontSize: "14px",
  textTransform: "none",
  boxShadow: "none",
  lineHeight: 1.5,
};

export const tabStyle = (isActive: boolean) => ({
  textTransform: "none",
  minHeight: 48,
  fontWeight: 600,
  color: isActive ? "#1D2939" : "#667085",
  backgroundColor: isActive ? "#F9FAFB" : "#ffffff",
  fontSize: "14px",
  border: isActive ? "1px solid #EAECF0" : "1px solid transparent",
  borderRadius: "8px",
  px: 2,
  boxShadow: isActive ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
});